import React from 'react';
import Transition from 'react-transition-group/Transition';
import classnames from 'classnames/bind';

import Notification from '../Notification';
import Icon from 'foundations/Icons/Icon';

import styles from './InlineNotification.css';

class InlineNotification extends Notification {
  static defaultProps = {
    role: 'alert',
    transitionDuration: 100
  }

  render () {
    const { title, children, role, timeout, transitionDuration } = this.props;

    return (
      <Transition timeout={transitionDuration} in={this.state.active} appear unmountOnExit>
        {(status) => (
          <div
            className={classnames('content-block', styles.notification, styles[status])}
            role={role}
            onMouseEnter={timeout && this.stopTimer}
            onMouseLeave={timeout && this.startTimer}
            style={{
              transitionDuration: `${transitionDuration}ms`
            }}
          >
            <div className={styles.informativeSection}>
              <p className={classnames('hotspot-title', styles.informativeTitle)}>
                {title}
              </p>
              <p className={classnames('p small', styles.informativeDescription)}>
                {children}
              </p>
            </div>
            <div className={styles.actionSection}>
              <a
                className={styles.closeButton}
                onClick={this.handleCloseButton}
                aria-label="close"
              >
                <Icon icon={'close'} type={'20'} responsive />
              </a>
            </div>
          </div>
        )}  
      </Transition>
    );
  }
}

export default InlineNotification;


// WEBPACK FOOTER //
// ./src/uis/components/Notification/InlineNotification/InlineNotification.js